<template>
  <div class="order-operation-claim-lines is-relative">
    <b-loading :is-full-page="false" :active="fetching"></b-loading>

    <b-modal :active.sync="modalClaimLine.active" has-modal-card>
      <order-operation-claim-lines-modal
        :order="order"
        :operation="operation"
        :operation-code-ids="operationCodeIds"
        :claim-line="modalClaimLine.data"
        @create-success="onCreateSuccess"
        @update-success="onUpdateSuccess"
      />
    </b-modal>

    <b-table :data="claimLines" :loading="deleting" narrowed class="invoice-table">

      <template slot-scope="props">

        <b-table-column field="code" label="Code">

          <p v-if="props.row.orderOperationClaimService.status != 0">{{ props.row.orderOperationClaimService.ninaCode }}</p>
          <p v-else><strike>{{ props.row.orderOperationClaimService.ninaCode }}</strike></p>

        </b-table-column>

        <b-table-column field="description" label="Description" style="border-right:0px;">

          <div style="display:flex;">

            <p style="display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow:hidden;" class="description"
            :title="props.row.orderOperationClaimService.description" v-if="props.row.orderOperationClaimService.status != 0">
            {{ props.row.orderOperationClaimService.description }}
            </p>

            <p style="display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow:hidden;" class="description"
            :title="props.row.orderOperationClaimService.description + ' - [ Archived ]'" v-else>
            <strike>{{ props.row.orderOperationClaimService.description }}</strike>
            </p>

          </div>

        </b-table-column>


        <b-table-column style="border-left:0px;">

          <div style="display:flex; margin-top:3px;">

            <b-tooltip multilined :label="props.row.details " type="is-dark" position="is-top" v-if="props.row.details" style="width:100%;">

              <i class="fa fa-info-circle" style="font-size:15px; position:absolute; right:0px;"></i>

            </b-tooltip>

          </div>

        </b-table-column>


        <b-table-column field="quantity" label="Quantity" class="has-text-right">
          {{ props.row.quantity }}
        </b-table-column>
        <b-table-column field="uom" label="UOM">
          {{ props.row.orderOperationClaimService.uom }}
        </b-table-column>


        <b-table-column field="rate" label="Rate $" numeric>

          <b-tooltip v-if="props.row.wbsCode" multilined :label="`${props.row.wbsCode.code} - ${props.row.wbsCode.name}`" type="is-dark" position="is-top">

              <i class="fa fa-info-circle" style="font-size:15px;"></i>

          </b-tooltip>

          {{ props.row.orderOperationClaimService.rate | numberPriceFormatterWithDollarSign }}

        </b-table-column>


        <b-table-column field="value" label=" Value $" numeric>
          <span class="is-pulled-right has-text-right">
            {{
              getProduct(
                props.row.orderOperationClaimService.rate,
                props.row.quantity
              ) | numberPriceFormatterWithDollarSign
            }}
          </span>
        </b-table-column>

        <b-table-column
          field="id"
          label
          class="no-wrap"
          narrowed
          v-if="
            canManageClaimLines &&
              canManageClaimLines.value &&
              canManageClaimLinesByUser && canManageClaimLinesByUser.value
          "
        >
          <b-button
            class="has-text-weight-bold edit_operation_claim_line"
            type="is-light"
            size="is-small"
            :disabled="(canManageClaimLinesByUser && canManageClaimLinesByUser.value === 'disabled') || !order.editable"
            :title="
              canManageClaimLinesByUser &&
              canManageClaimLinesByUser.value === 'disabled'
                ? canManageClaimLinesByUser.help[0]
                : ''
            "
            @click="onUpdate(props.row)"
          >
            EDIT
          </b-button>
          <b-button
            class="has-text-weight-bold"
            type="is-light"
            size="is-small"
            :disabled="(canManageClaimLinesByUser && canManageClaimLinesByUser.value === 'disabled') || !order.editable"
            :title="
              canManageClaimLinesByUser &&
              canManageClaimLinesByUser.value === 'disabled'
                ? canManageClaimLinesByUser.help[0]
                : ''
            "
            @click="onVoid(props.row)"
          >
            VOID
          </b-button>
          <b-button
            class="has-text-weight-bold"
            type="is-light"
            size="is-small"
            :disabled="(canManageClaimLinesByUser && canManageClaimLinesByUser.value === 'disabled') || !order.editable"
            :title="
              canManageClaimLinesByUser &&
              canManageClaimLinesByUser.value === 'disabled'
                ? canManageClaimLinesByUser.help[0]
                : ''
            "
            @click="onRemove(props.row)"
            v-if="canPermanentlyDeleteRecords"
          >
            DELETE
          </b-button>
        </b-table-column>
      </template>

      <template slot="empty">No claim lines found.</template>

      <template slot="footer" v-if="claimLines.length > 0">

        <th colspan="5"></th>

        <th style="padding: 25px 5px 20px;">
          <b>TOTAL </b>
          <!-- <div class="th-wrap"></div> -->
        </th>
<!--         <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th> -->
        <th style="padding: 25px 5px 20px;">

          <div class="th-wrap is-pulled-right no-wrap"> {{ getTotalValues(claimLines) | numberPriceFormatterWithDollarSign }}</div>
        </th>
        <th style="padding: 25px 5px 20px;">
          <div class="th-wrap is-centered"></div>
        </th>
        <!-- <div class="columns">
          <div class="column"  field="value">
            <b>Total Value</b>: ${{ getTotalValues(claimLines)}}
          </div>
        </div>-->
      </template>
    </b-table>
  </div>
</template>

<script>
import OrderOperationClaimLinesModal from "./OrderOperationClaimLinesModal";
import { OrderOperationClaimLineService } from "@/services/orderOperationClaimLine.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  orderOperationClaimLineService: OrderOperationClaimLineService,
  props: {
    order: {
      type: Object,
      required: true
    },
    operationId: {
      type: Number | String,
      required: true
    },
    operation: {
      type: Object,
      required: true
    },
    operationCodeIds: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    OrderOperationClaimLinesModal
  },
  data: () => ({
    claimLines: [],
    modalClaimLine: {
      data: null,
      active: false
    },
    fetching: false,
    deleting: false
  }),
  computed: {
    canManageClaimLines() {
      return this.$store.getters["OrderState/getStateByKey"](
        "can_manage_claim_lines"
      );
    },
    canManageClaimLinesByUser() {
      return this.$store.getters["OrderState/getStateByKey"](
        "can_manage_claim_lines_by_user"
      );
    },
    canPermanentlyDeleteRecords() {
      return this.$store.getters["Auth/hasPermission"](
        "can permanently delete records"
      );
    }
  },
  mounted() {
    // this.fetch();
    this.$nextTick(() => {
      // console.log(this.operation.orderOperationClaimLines);
      this.claimLines = this.operation.orderOperationClaimLines || [];
    });
  },
  watch: {
    claimLines(claimLines) {
      this.$emit("update:claimLines", claimLines);
    },
    operation(value) {
      // Fix - no default value if orderOperationClaimLines is undefined. Having errors in orderOperation because of undefined claimLines
      this.claimLines = value.orderOperationClaimLines || [];
    }
  },
  methods: {
    getObjectValue(obj, path) {
      return path.split(".").reduce((acc, val) => {
        acc = acc[val] || "";
        return acc;
      }, obj);
    },
    getProduct(multiplicand, multiplier) {
      const product = multiplicand * multiplier;
      return product.toFixed(2);
    },
    // async fetch() {
    //   this.fetching = true;

    //   try {
    //     this.claimLines = await this.$options.orderOperationClaimLineService
    //       .all(this.operationId)
    //       .then(response => JsonDenormalizer.denormalize(response));
    //   } catch (err) {
    //     this.$buefy.toast.open({
    //       message: "Failed to fetch claim lines.",
    //       type: "is-danger",
    //       position: "is-top-right"
    //     });
    //   }

    //   this.fetching = false;
    // },
    async remove(id) {
      this.deleting = true;

      try {
        await this.$options.orderOperationClaimLineService.delete(
          this.operationId,
          id
        );

        let index = this.claimLines.findIndex(cl => cl.id === id);

        if (index > -1) {
          this.claimLines.splice(index, 1);
        }

        this.$buefy.toast.open({
          message: "Claim line has been deleted.",
          type: "is-info",
          position: "is-top-right"
        });

        this.$nextTick(() => {
          if (this.claimLines.length == 0) {
            this.$emit("allClaimLinesDeleted");
          }
        });

        this.$emit("removed");
      } catch (err) {}

      this.deleting = false;
    },
    async void(id) {
      this.voiding = true;

      try {
        await this.$options.orderOperationClaimLineService.void(
          this.operationId,
          id
        );

        let index = this.claimLines.findIndex(cl => cl.id === id);

        if (index > -1) {
          this.claimLines.splice(index, 1);
        }

        this.$buefy.toast.open({
          message: "Claim line has been voided.",
          type: "is-info",
          position: "is-top-right"
        });

        this.$nextTick(() => {
          if (this.claimLines.length == 0) {
            this.$emit("allClaimLinesDeleted");
          }
        });

        this.$emit("removed");
      } catch (err) {}

      this.voiding = false;
    },
    onCreate() {
      this.modalClaimLine.data = null;
      this.modalClaimLine.active = true;
    },
    onCreateSuccess(claimLine) {
      this.claimLines.push(claimLine);
      this.$emit("created");
    },
    onUpdate(claimLine) {
      this.modalClaimLine.data = claimLine;
      this.modalClaimLine.active = true;
    },
    onUpdateSuccess(claimLine) {
      let index = this.claimLines.findIndex(cl => cl.id === claimLine.id);

      if (index > -1) {
        // this.claimLines[index] = claimLine;
        this.$set(this.claimLines, index, claimLine)
        this.$nextTick(() => {
          this.operation.orderOperationClaimLines = this.claimLines;
        });
      }
    },
    onRemove(claimLine) {
      this.$buefy.dialog.confirm({
        title: "Confirm",
        message: "Are you sure you want to <b>delete</b> this claim line?",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.remove(claimLine.id);
        }
      });
    },
    onVoid(claimLine) {
      this.$buefy.dialog.confirm({
        title: "Confirm",
        message: "Are you sure you want to <b>void</b> this claim line?",
        confirmText: "Void",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.void(claimLine.id);
        }
      });
    },
    getTotalValues(claimLines) {
      var total = 0;
      claimLines.forEach(data => {
        total = total + data.orderOperationClaimService.rate * data.quantity;
      });
      return total.toFixed(2);
    }
  }
};
</script>

<style scoped>
.order-operation-claim-lines {
  word-break: initial;
}
.no-wrap {
  white-space: nowrap;
}
.table-footer > th {
  border: none;
}

/*.description:hover{

  display: unset !important;
  -webkit-line-clamp: unset !important;
  -webkit-box-orient: unset !important;
  overflow:unset !important;

}
*/
</style>

<style>

  .invoice-table thead th:nth-child(2){
    border-right:0px !important;
  }
  .invoice-table thead th:nth-child(3){
    border-left:0px !important;
  }

  .invoice-table thead th{
    white-space: nowrap;
  }


</style>


// WEBPACK FOOTER //
// src/components/Order/OrderOperationClaimLines.vue